var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"download","transform":"translate(-67 -230)"},[React.createElement("rect",{"id":"Rectangle_1637","data-name":"Rectangle 1637","width":"36","height":"36","rx":"5","transform":"translate(67 230)","fill":"#f2f2f2","key":0}),React.createElement("path",{"id":"download-2","data-name":"download","d":"M181.712,287.078A1.73,1.73,0,0,1,180,285.367v-3.694h1.346v3.694a.393.393,0,0,0,.365.365h14.373a.393.393,0,0,0,.365-.365v-3.694H197.8v3.694a1.73,1.73,0,0,1-1.711,1.711Zm7.186-4.458-4.914-4.914.967-.956,3.274,3.262V269.078h1.346v10.935l3.274-3.262.967.956Z","transform":"translate(-104.001 -30.078)","key":1})]));
}

Download.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Download;

Download.default = Download;
